import React, { Suspense, useEffect, useState } from "react";
import { Switch } from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import initialState from "./reducers/initialState";
import PublicRoute from "./routers/PublicRoute";
import PrivateRoute from "./routers/PrivateRoute";

import "./Translations/i18n";
import "../src/Style/App.scss";
import "./bootstrap_customized.css";
import "./Style/floatingInput.scss";
import "./Style/colors.scss";
import "./Style/en.scss";
import { Spinner } from "./utils/_Loader/Spinner";
import { getCookie } from "./actions/auth";

const store = configureStore(initialState).store;

const HomePage = React.lazy(() => import("./Components/Home/HomePage"));
const LoginPage = React.lazy(() =>
  import("./Components/Login_Service/LoginPage")
);
const ProjectPanel = React.lazy(() =>
  import("./Components/ProjectPanel/ProjectPanel")
);
const PasswordRecovery = React.lazy(() =>
  import("./Components/Login_Service/PasswordRecovery")
);
const NoService = React.lazy(() => import("./utils/ErrorPages/NotService"));

function App() {
  return (
    <div className="app" id="app">
      <Provider store={store}>
        <Suspense
          fallback={
            <div id="suspend">
              <Spinner />
            </div>
          }
        >
          <div className="h-100">
            <Switch>
              <PublicRoute path="/NoService" component={NoService} />
              <PublicRoute exact path="/" component={LoginPage} />
              <PrivateRoute path="/dashboard" component={ProjectPanel} />
              <PrivateRoute path="/Home" component={HomePage} />
              <PublicRoute
                path="/PasswordRecovery"
                component={PasswordRecovery}
              />
            </Switch>
          </div>
        </Suspense>
      </Provider>
    </div>
  );
}

export default App;
